/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentsRequestContext {
    getFixupPrototypeFunction() { return AwsSsmListDocumentsRequestContext.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentsRequestContext>): AwsSsmListDocumentsRequestContext {
        let obj = Object.assign(new AwsSsmListDocumentsRequestContext(), model);
        AwsSsmListDocumentsRequestContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentsRequestContext>): AwsSsmListDocumentsRequestContext {
        if (!model) return null;
        return AwsSsmListDocumentsRequestContext.newInstance(<AwsSsmListDocumentsRequestContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentsRequestContext) {
        if (!obj) return;

        models.AwsSsmListDocumentsRequestContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentsRequestContext): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentsRequestContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query_filter) {
            models.QueryOperator.fixupPrototype(this.query_filter);
        }
    }

    /**
     * id of the cloud accounts.
     */
    cloud_account_ids: Array<string>;

    /**
     * region of the document to be executed.
     */
    regions: Array<string>;

    /**
     * Name of the document.
     */
    document_names: Array<string>;

    /**
     * Owner of the SSM document.
     */
    owners: Array<string>;

    /**
     * Platform types supported for the document.
     */
    platform_types: Array<string>;

    /**
     * Type of the document.
     */
    document_types: Array<string>;

    /**
     * Text query for SSM Documents List. Search by Document Name, Category and Owner
     */
    text_query: string;

    query_filter: models.QueryOperator;

}
